export default {
  meta: {
    title: '门店客流成本分析'
  }
};
